
export const getPlanType = (planId) => {
  if (planId.includes('monthly')) return 'monthly';
  if (planId.includes('annual') || planId.includes('year')) return 'annual';
  if (planId.includes('gift')) return 'gift';
  return 'free';
};
export default getPlanType;
